import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';

import { Application } from "@yulintu/freesia-bootstrap";

import useDesigner from "../hooks/useDesigner";
import useDesignerMessage from "../hooks/useDesignerMessage";

export default function Addon(props) {

    const designer = useDesigner();
    const [action, setAction] = useState(designer.action);

    useDesignerMessage(e => {
        setAction(e);
    }, "actionChanged");

    return <>
        <Tooltip title="选取工具" placement="bottom">
            <Button className='btn-switch' type={action === null ? "primary" : "default"} onClick={e => designer.action = null} ><Application.SystemSvgIcon type="cursor-alt-pointer-mouse" /></Button>
        </Tooltip>
    </>
}